import { useTranslation } from 'react-i18next';
import useIsNHS from '@hooks/useIsNHS';

export const useDisplayCancellationAndExcessText = () => {
  const isNHS = useIsNHS();
  const { t } = useTranslation();

  if (!isNHS && t) return t('CancellationAndExcessMessage') || '';

  return '';
};
export default useDisplayCancellationAndExcessText;
